import { useEffect, useState, useCallback } from 'react';

function getIsMatch(query: string): boolean {
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query: string): boolean {
  const [isMatch, setIsMatch] = useState(getIsMatch(query));

  const handleChange = useCallback(() => setIsMatch(getIsMatch(query)), [query]);

  useEffect(() => {
    const matchMedia = window.matchMedia(query);

    // Triggered at mount and if query changes
    handleChange();

    // Listen for media change
    matchMedia.addEventListener('change', handleChange);

    return () => matchMedia.removeEventListener('change', handleChange);
  }, [query, handleChange]);

  return isMatch;
}
